class Help {
  constructor (data) {
    this.id = data ? data.id : ''
    this.user_id = data ? data.user_id : null
    this.email = data ? data.email : ''
    this.username = data ? data.username : ''
    this.message = data ? data.message : ''
    // eslint-disable-next-line eqeqeq
    this.is_closed = data ? (data.is_closed == 1) : false
    this.closed_date = data ? data.closed_date : null
    this.created_at = data ? data.created_at : null
  }
}

export default Help



// WEBPACK FOOTER //
// ./src/models/help.js